export default "/assets/images/big-sneeze1.d0e42f0e558133a8.png";